<template>
    <div class="row p-sr pt-3 bg-white">
        <div class="col-md-10 col-sm-12" id="sub-menu">
            <md-tabs :md-active-tab="actual" class="md-primary">
                <md-tab  :md-label="item.titulo" :md-template-data="item" :key="index" v-for="(item,index) in pasos" md-disabled :id="item.titulo" />
                <template slot="md-tab" slot-scope="{ tab }">
                    <span class="d-none d-md-block d-lg-block d-sm-none">
                        {{ tab.label }}
                    </span>
                    <span class="d-sm-block d-xs-block d-md-none">
                        <i :class="tab.data.icono"></i>
                    </span>
                </template>
            </md-tabs>
        </div>
        <div class="col-md-2">
            <md-tabs md-alignment="right" md-active-tab="otro" md-disabled class="md-primary" >
                <md-tab  id="PVP" v-on:click="abrirResumen" disabled="" />
                <template slot="md-tab">
                    <div class="pvp row col-12 text-right md-accent">
                        <span class="col">PVP. Sugerido <span class="fa fa-info-circle"></span></span>
                        <span class="col"><numero-animado :number="precio"></numero-animado></span>
                    </div>
                </template>
            </md-tabs>
        </div>
        <b-modal v-model="ventana" size="xl" centered hide-footer  title="Resumen">
            <fade-transition origin="center" mode="in-out" :duration="3">
                <resumen-modal :estado="precio"/>
            </fade-transition>
        </b-modal>
    </div>
</template>

<script>
    import NumeroAnimado from "../componentes/numero-animado";
    import constantes from "../constantes";
    import ResumenModal from "../vistas/Paso3/resumen-modal";
    import { FadeTransition } from "vue2-transitions";
    export default {
        name: "nav-paso2",
        data:()=>({
            numero:1000,
            ventana:false,
        }),
        components:{NumeroAnimado,ResumenModal,FadeTransition},
        props:{
            pasos: {
                type: Array,
                required: false,
                default: function () { return [] }
            },
        },
        methods:{
            abrirResumen:function(){
                this.ventana=true;
            }
        },
        computed:{
            actual:function() {
                return this.$store.getters.getSubActual
            },
            precio:function(){
                let accesorios = this.$store.getters.getPasos[2] ? constantes.funciones.sumar2(this.$store.getters.getPasos[2].accesorios.individuales,this.$store.getters.getPasos[2].accesorios.kit) :0 ;
                let cupones = this.$store.getters.getPasos[2] ? constantes.funciones.sumar3('ndt3',this.$store.getters.getPasos[2].accesorios.cupones) :0 ;
                return this.$store.getters.getPrecio + accesorios + cupones;
            },
        },
    }
</script>

<style scoped>
    .col-md-10 , .col-md-2 , .col-12{
        padding: 0px;
    }
    .pvp{
        color: white !important;
    }
    .p-sr{
        /*padding-right: 10px;*/
        /*padding-left: 10px;*/
    }
</style>
